import { ContentType } from "./common";
import { Media } from "./media";

export enum TemplateType {
  LinkedIn = "linkedin"
}

export interface IShareTemplate {
  message : string;
  banner : Media;
}

export interface IFetchShareTemplateRequest {
  entityId :string;
  entityType : ContentType;
  templateType: TemplateType;
}


export interface IFetchShareTemplateResponse {
  response: IShareTemplate;
  entityId : string;
  entityType : ContentType;
}

export interface IFetchShareTemplateErrorResponse {
  error: any;
  entityId : string;
  entityType : ContentType;
}

export interface IUpdateShareTemplateRequest {
  entityId : string;
  entityType : ContentType;
  templateType: TemplateType;
  requestBody: {
    message: string;
    media: string;
    type: TemplateType;
  }
}

export interface IUpdateShareTemplateResponse {
  response: {
    mediaDTO : Media,
    message: string
  };
  entityId : string;
  entityType : ContentType;
}

export interface IUpdateShareTemplateErrorResponse {
  error: any;
  entityId : string;
  entityType : ContentType;
}

export interface IInvalidShareSettingsUpdate {
  entityId: string,
  entityType : ContentType;
}

export interface ILinkedInShareRequest {
  entityId: string,
  entityType : ContentType;
  requestBody : {
    sharedUrl: string;
    sharedUrlId : string;
    message : string;
    media: string;
  }
}

export enum IRephraseTones {
  FORMAL = "FORMAL",
  INFORMAL = "INFORMAL",
  LIGHTHEARTED = "LIGHTHEARTED",
}

export interface IRephraseRequest{
  entityId: string,
  message : string;
  rephraseTone: IRephraseTones;
}

export interface IRephraseResponse{ 
  entityId: string,
  response: any,
  rephraseTone: IRephraseTones;
}

export interface IRephraseErrorResponse {
  entityId: string,
  error: any,
  rephraseTone: IRephraseTones,
}
